"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardBlockedDomainsOption_1 = require("./actions/discardBlockedDomainsOption");
var saveBlockedDomainsOption_1 = require("./actions/saveBlockedDomainsOption");
var BlockedDomainsFull_1 = require("./components/BlockedDomainsFull");
var isBlockedDomainsOptionDirty_1 = require("./utils/isBlockedDomainsOptionDirty");
var React = require("react");
var BlockedDomainsOption = {
    key: 'blockedDomains',
    titleStringKey: 'optionTitle_blockedDomains',
    searchTermsStringKey: 'optionSearchTerms_blockedDomains',
    fullOptionFormSettings: {
        render: function () { return React.createElement(BlockedDomainsFull_1.default, null); },
        isDirty: isBlockedDomainsOptionDirty_1.default,
        onSave: saveBlockedDomainsOption_1.default,
        onDiscard: discardBlockedDomainsOption_1.default,
    },
};
exports.default = BlockedDomainsOption;
//# sourceMappingURL=BlockedDomainsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-domains-option/lib/BlockedDomainsOption.js
// module id = 5015
// module chunks = 2